<template>
    <div style="overflow:hidden;width:1585px;margin-left:150px">
      <iframe :src="url" frameborder="0" width="1600"  class="frame" id="iframepage" @load="changeFrameHeight" ></iframe>
    </div>
</template>

<script>
export default {
  data () {
    return {
      url: ''
    }
  },
  created () {
    this.look()
  },
  methods: {
    look () {
      let self = this
      self.url = '/api/publish/get?publish_id=' + sessionStorage.getItem('publish_id')
    },
    changeFrameHeight () {
      var ifm = document.getElementById('iframepage')
      ifm.height = document.documentElement.clientHeight
      ifm.width = document.documentElement.clientWidth
    }
  }
}
</script>
